import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=64a2413b&scoped=true"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"
import style0 from "./TaskModal.vue?vue&type=style&index=0&id=64a2413b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2413b",
  null
  
)

export default component.exports